import { React } from 'react';
import { Col, Row } from 'react-bootstrap';

// Renders `<prefix>` as side-by-side cards (stacked on mobile): one card per key, each with
// a `title` and numbered rows (`label` / `value`); the `highlight` card gets the brand colour
const SatelliteComparison = props => {
    const cards = props.t(props.prefix, { returnObjects: true });
    return (
        <div className='container-custom subtitle satellite-comparison'>
            <div className='comparison-wrapper'>
                <Row className='g-3'>
                    {Object.keys(cards).map(card => (
                        <Col key={card} md={6}>
                            <div className={card === props.highlight ? 'comparison-card highlight' : 'comparison-card'}>
                                <div className='comparison-title'>{cards[card].title}</div>
                                {Object.keys(cards[card]).filter(key => !isNaN(key)).map(row => (
                                    <div key={row} className='comparison-row'>
                                        <div className='comparison-label'>{cards[card][row].label}</div>
                                        <div className='comparison-value'>{cards[card][row].value}</div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default SatelliteComparison;
